export enum AggregatedPeriod {
  Weekly = 7,
  Monthly = 30,
}

export const mapTrendsParameter: {
  [key: string]: string;
} = {
  tug: 'tug_duration_seconds',
  sts: 'sts_repetition_count',
  walk_6_min_test: 'six_minute_walk_distance_meters',
  PlusM: 'plus_m_score',
  amppro: 'amppro_score',
  lefs: 'lefs_score',
  vas: 'vas_score',
  'Functional Scale': 'psfs_score',
  "Fear of Falls": 'fear_of_falls_score',
};
